export const TEMPLATE_TYPE_TABS = [
  {
    id: 'email',
    label: 'Email Templates',
    title: 'Email Templates',
    subtitle: 'Create and manage templates for all of your emails.',
    searchPlaceholder: 'Search Email Templates',
    typeLabel: 'Design editor',
    icon: 'mail',
  },
  {
    id: 'sms',
    label: 'SMS Templates',
    title: 'SMS Templates',
    subtitle: 'Create and manage reusable SMS messages for campaigns and workflows.',
    searchPlaceholder: 'Search SMS Templates',
    typeLabel: 'SMS editor',
    icon: 'message',
  },
  {
    id: 'notification',
    label: 'Notification Templates',
    title: 'Notification Templates',
    subtitle: 'Create and manage internal notification templates for staff and system alerts.',
    searchPlaceholder: 'Search Notification Templates',
    typeLabel: 'Notification editor',
    icon: 'bell',
  },
];

export const TEMPLATE_LIBRARY_ROWS = {
  email: [
    {
      id: 'email-new-template',
      title: 'New Template',
      type: 'Design editor',
      updatedOn: 'Jul 05, 2026 07:22 pm',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'email-default-document-sent',
      title: 'Default - Document Sent',
      type: 'Design editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'email-marketing-sales-strategy',
      title: 'Marketing & Sales Strategy',
      type: 'Design editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'email-financial-planning-analysis',
      title: 'Financial Planning & Analysis',
      type: 'Design editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'email-performance-management',
      title: 'Performance Management',
      type: 'Design editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'email-strategic-planning',
      title: 'Strategic Planning',
      type: 'Design editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'email-leadership-development',
      title: 'Leadership Development',
      type: 'Design editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
  ],

  sms: [
    {
      id: 'sms-appointment-reminder',
      title: 'Appointment Reminder SMS',
      type: 'SMS editor',
      updatedOn: 'Jul 05, 2026 07:22 pm',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'sms-payment-failed',
      title: 'Payment Failed SMS',
      type: 'SMS editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'sms-trial-ending',
      title: 'Trial Ending SMS',
      type: 'SMS editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'sms-password-reset',
      title: 'Password Reset SMS',
      type: 'SMS editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'sms-welcome',
      title: 'Welcome SMS',
      type: 'SMS editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'sms-document-request',
      title: 'Document Request SMS',
      type: 'SMS editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'sms-follow-up',
      title: 'Follow Up SMS',
      type: 'SMS editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
  ],

  notification: [
    {
      id: 'notification-new-lead-assigned',
      title: 'New Lead Assigned',
      type: 'Notification editor',
      updatedOn: 'Jul 05, 2026 07:22 pm',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'notification-workflow-failed',
      title: 'Workflow Failed Alert',
      type: 'Notification editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'notification-password-reset-completed',
      title: 'Password Reset Completed',
      type: 'Notification editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'notification-payment-failure',
      title: 'Payment Failure Alert',
      type: 'Notification editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'notification-new-document-uploaded',
      title: 'New Document Uploaded',
      type: 'Notification editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'notification-dispute-status-changed',
      title: 'Dispute Status Changed',
      type: 'Notification editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
    {
      id: 'notification-task-due-reminder',
      title: 'Task Due Reminder',
      type: 'Notification editor',
      updatedOn: 'Mar 07, 2026 10:09 am',
      updatedBy: 'Dieumerson Thomas',
      status: 'active',
    },
  ],
};

export const DEFAULT_TEMPLATE_PAGE_SIZE = 10;

export function getTemplateTypeTab(tabId) {
  return TEMPLATE_TYPE_TABS.find((tab) => tab.id === tabId) || TEMPLATE_TYPE_TABS[0];
}

export function getTemplateRowsForTab(tabId) {
  return TEMPLATE_LIBRARY_ROWS[tabId] || [];
}

export function filterTemplateRows(rows, searchQuery) {
  const query = String(searchQuery || '').trim().toLowerCase();
  if (!query) return rows;

  return rows.filter((row) => {
    const haystack = `${row.title || ''} ${row.type || ''} ${row.updatedBy || ''}`.toLowerCase();
    return haystack.includes(query);
  });
}

export function paginateTemplateRows(rows, page, pageSize = DEFAULT_TEMPLATE_PAGE_SIZE) {
  const safePageSize = Math.max(1, Number(pageSize) || DEFAULT_TEMPLATE_PAGE_SIZE);
  const total = rows.length;
  const totalPages = Math.max(1, Math.ceil(total / safePageSize));
  const safePage = Math.min(Math.max(1, Number(page) || 1), totalPages);
  const startIndex = (safePage - 1) * safePageSize;
  const endIndex = Math.min(startIndex + safePageSize, total);

  return {
    rows: rows.slice(startIndex, endIndex),
    page: safePage,
    pageSize: safePageSize,
    total,
    totalPages,
    startIndex: total === 0 ? 0 : startIndex + 1,
    endIndex,
  };
}

export function getTemplateResultsSummary(startIndex, endIndex, total) {
  if (!total) return 'Showing 0 results';
  return `Showing ${startIndex} - ${endIndex} of ${total} results`;
}

export function getAvatarInitial(name) {
  const value = String(name || '').trim();
  return value ? value.charAt(0).toUpperCase() : '?';
}
